import { Content, Heading, IllustratedMessage, Link, Paragraph } from "@hopper-ui/components";
import { ErrorIllustration } from "@sg-protect/components";
import { Trans } from "@sg-protect/federation-runtime/i18n";
import { useShellTranslation } from "../i18n/i18next.ts";
import { ErrorLayout } from "./ErrorLayout.tsx";

export interface NotFoundErrorProps {
    homeUrl: string;
}

export function NotFoundError({ homeUrl }: NotFoundErrorProps) {
    const { t, i18n } = useShellTranslation();

    return (
        <ErrorLayout>
            <IllustratedMessage size="lg">
                <ErrorIllustration fill="neutral" aria-label={t("NotFoundError.illustration")} />
                <Heading size="3xl" level={1}>
                    {t("NotFoundError.title")}
                </Heading>
                <Content>
                    <Paragraph marginBottom="stack-xl">
                        <Trans
                            i18n={i18n}
                            ns="shell"
                            i18nKey="NotFoundError.description"
                            components={{ homeLink: <Link href={homeUrl} /> }}
                        />
                    </Paragraph>
                    <Paragraph>
                        <Trans
                            i18n={i18n}
                            ns="shell"
                            i18nKey="NotFoundError.contactSupport"
                            components={{
                                supportLink: (
                                    <Link href="https://help.sharegate.com/en/articles/10236088-contact-our-technical-support-team" />
                                )
                            }}
                        />
                    </Paragraph>
                </Content>
            </IllustratedMessage>
        </ErrorLayout>
    );
}
